import "@/App.css";
import { useLayoutEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Marianne from "@/pages/Marianne";
import Confidentialite from "@/pages/Confidentialite";

function RouteScroll() {
  const { pathname } = useLocation();
  useLayoutEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors closeButton />
      <BrowserRouter>
        <RouteScroll />
        <Routes>
          <Route path="/" element={<Marianne />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
